import { onValue } from '@/features/firebase/adapter/database'
import FirebaseDatabaseRefService from '@/features/firebase/services/database-ref'
import { ReadNotifications } from '@/features/notifications/components/NotificationCenter/types'
import { useEffect, useState } from 'react'

export const useFirebaseReadNotifications = (): ReadNotifications => {
    const [readNotifications, setReadNotifications] = useState({})

    useEffect(() => {
        const ref = FirebaseDatabaseRefService.readNotifications()

        return onValue(ref, (snapshot) => {
            if (!snapshot.exists()) return

            setReadNotifications(snapshot.val())
        })
    }, [])

    return readNotifications
}
